import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'fly-down-for-maintenance',
  imports: [RouterModule],
  templateUrl: './down-for-maintenance.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './down-for-maintenance.component.scss'
})
export class DownForMaintenanceComponent {
  legacyHomePage: string = environment.legacyFlyAdmin;
}
